// @ts-nocheck
/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * SUREnet alerts-public API
 * OpenAPI spec version: 1
 */

export type AlertsFeaturesAlertPolisTypeOntvanger =
  (typeof AlertsFeaturesAlertPolisTypeOntvanger)[keyof typeof AlertsFeaturesAlertPolisTypeOntvanger];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlertsFeaturesAlertPolisTypeOntvanger = {
  Adviseur: 'Adviseur',
  Relatie: 'Relatie',
} as const;
